import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector, ChangeDetectionStrategy} from '@angular/core';
import {SettingsService} from "../../../../../services/sys/settings.service";
import {Hits} from "../../../../../services/model/hits";
import {Observable, Subscription} from "rxjs";
import {ApplicationService} from "../../../../../services/domain/application.service";
import {ModalService} from "../../../../../services/ui/modal.service";
import {TablePositionStatus} from "../../../../../services/model/tablePositionStatus";
import {QueryManagerService} from "../../../../../services/domain/query-manager.service";

@Component({
    selector: 'efast-paginator',
    templateUrl: 'efast-paginator.component.html',
    styleUrls: ['efast-paginator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastPaginatorComponent implements OnInit {

    @Input() efastIsShown: boolean = false;
    @Input() events: Observable<void>;

    countList: number[] = new Array();
    recordsMax: number = 0;
    efastHits: Hits | null = null;
    private eventsSubscription: Subscription;
    private applicationService: ApplicationService;
    private queryManagerService: QueryManagerService;

    constructor(protected injector: Injector,
                protected settingsService: SettingsService) {
        this.applicationService = injector.get(ApplicationService);
        this.queryManagerService = injector.get(QueryManagerService);
    }

    ngOnInit() {
        this.settingsService.getRecordsMax()
        this.recordsMax =Number(this.settingsService.getRecordsMax());

        this.eventsSubscription = this.events.subscribe(() => this.searchChangeEvent());
    }

    searchChangeEvent() {
        this.countList = new Array();

        if (this.applicationService.getAfsForm().hits != null) {

            let count: number = this.applicationService.getAfsForm().hits.found;

            if (this.applicationService.getAfsForm().hits.found >= Number(this.settingsService.getRecordsMaxTotal())) {
                count = Number(this.settingsService.getRecordsMaxTotal());
            }

            let idx: number = 0;
            for (let i = 0; i < count; i = i + this.recordsMax) {
                this.countList.push(i)
                idx++
            }

        }
    }

    isactive(idx: number) : string {
        let returnHighlight: string = "";
        if ( idx.toString() == this.applicationService.getTablePositionStatus().paginatorPos) {
            returnHighlight = "usa-button--active";
        }
        return returnHighlight;
    }
    pageSelected(pos: number) {

        let tablePositionStatus: TablePositionStatus  = this.applicationService.getTablePositionStatus();

        tablePositionStatus.paginatorPos= pos.toString();
        tablePositionStatus.isPaginatorEvent = true;
        this.applicationService.setTablePositionStatus(tablePositionStatus);

        this.queryManagerService.refresh();
    }

}